import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP1FloorBudgetNew202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p1_floor_budget_new_202606",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 67,
  clicks: 1,
  adsSpendDollars: 3,
  budgetDollars: 200,
  salesDollars: 0,
  bestEstimateRoas: 0,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.01,
  newCustomersAcquired: 0,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
